export default __webpack_public_path__ + "static/media/omoda-universe.c8cd12a1.webp";